import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import './Main.sass';

import GridDisplay from './GridDisplay';
import ListDisplay from './ListDisplay';
import SingleImageEvaluation from './SingleImageEvaluation';
import BatchEvaluation from './BatchEvaluation';
import SelectedImagePaper from './SelectedImagePaper';

const Main = () => (
  <main>
    <div className="main-wrapper">
      <Route exact path="/" render={() => <Redirect push to="/images/grid" />} />
      <Route exact path="/images">
        <span>
          <Route
            exact
            path="/images/grid"
            component={GridDisplay}
          />
          <Route
            exact
            path="/images/grid/:imageID/:imageContent"
            component={SingleImageEvaluation}
          />
          <Route
            exact
            path="/images/list"
            component={ListDisplay}
          />
          <Route
            exact
            path="/images/list/:imageID/:imageContent"
            component={SingleImageEvaluation}
          />
          <Route
            exact
            path="/images/batch_evaluation"
            component={BatchEvaluation}
          />
        </span>
      </Route>
    </div>
    <SelectedImagePaper />
  </main>
);

export default withRouter(Main);



// WEBPACK FOOTER //
// ./src/containers/Main/Main.jsx